export default {
  en: {
    unavailable: 'Not available',
  },
};
